import React, { useEffect, useRef, useCallback, useState, useMemo } from 'react';
import './BrowserTop.css';
import { f_isSignInWithEmailLink, f_signInWithEmailLink, auth } from '../Util/Firebase';
import { useNavigate, useLocation } from 'react-router-dom';
import AddAccess from '../Util/AddAccess';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { isAuthAtom, topMessageAtom, isAuthLoadedAtom } from '../../State';
import { ReactComponent as CopyLinkSVG } from '../Images/buttons/linkCopyGray.svg';
import { ReactComponent as DotsSVG } from '../Images/buttons/topdots.svg';
import { ReactComponent as InfinieSVG } from '../Images/buttons/infiniteMeetingIcon.svg';
import { ReactComponent as MeetingSVG } from '../Images/buttons/newMeeting.svg';
import { ReactComponent as LiveSVG } from '../Images/buttons/newLive.svg';
import { ReactComponent as JoinSVG } from '../Images/buttons/join.svg';
import { ReactComponent as TrashSVG } from '../Images/buttons/Trash.svg';
import { ReactComponent as LiveLeftSVG } from '../Images/buttons/liveLeftIcon.svg';
import { ReactComponent as EditSVG } from '../Images/buttons/edit.svg';
import { ReactComponent as UnlimitedSVG } from '../Images/buttons/unlimtedButton.svg';
import DataModel from '../Util/DataModel';
import { format } from 'date-fns';

export default function Error({ showError, setShowError }) {
  const navigate = useNavigate(); //リダイレクト用
  const { t } = useTranslation();

  //Recoil系
  const [authState, setAuthState] = useRecoilState(isAuthAtom);
  const [isAuthLoadedState, setIsAuthLoadedState] = useRecoilState(isAuthLoadedAtom);

  //もっとを選択
  const close = (e) => {
    setShowError(null);
  };

  return (
    <>
      <>
        <div className="addAreaBack" onClick={close}></div>
        <div className="moreAreaWrap">
          <div className="mypageErrorWrap">
            <div className="mypageErrorTitle">
              {t('mypage.The unlimited meeting already exists')}
            </div>
            <div className="mypageErrorBody">{t('mypage.The unlimited meeting...')}</div>
            <button onClick={close}>{t('setting.Close')}</button>
          </div>
        </div>
      </>
    </>
  );
}
